const isDescendant = (child, parentID, customSelector) => {
    let node = child.parentNode;
    while (node != null) {
        if (customSelector && (node === null || node === void 0 ? void 0 : node.dataset) && (node === null || node === void 0 ? void 0 : node.dataset[customSelector]) === parentID) {
            return true;
        }
        else if (node.id === parentID) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
};
export default isDescendant;
